<div class="c-container c-text-center c-body-text ea-no-data">
    <i class="ea-no-activity-data-icon"></i>
    <h2 class="c-header-xl c-m-bottom-0">{{ 'bd/event-activity/form.no_data_header' | translate }}</h2>
    <div class="ea-no-data-text c-m-bottom-sm">{{ 'bd/event-activity/form.no_data_text' | translate }}</div>
    <button (click)="close.emit()"
            class="c-btn c-btn-primary">
        {{'bd/event-activity/form.close' | translate}}
    </button>
</div>